import { Component, TemplateRef, ViewChild } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import { ActionType, ModelTemplate, SmartSearchState } from 'mbs-ui-kit';
import { Observable, of, switchMap } from 'rxjs';
import { SmartSearchFilterValue } from 'mbs-ui-shared@modules/smart-search-templates/models/smart-search-templates-models';

@Component({
  selector: 'mbs-smart-search-base-template',
  templateUrl: './smart-search-base-template.component.html'
})
export class SmartSearchBaseTemplateComponent {
  constructor(public i18nPipe: I18NextPipe) {}

  public tag = '';
  public filterPropertyName = 'value';

  public isSequenceMultiple = true;
  public enableCacheStorage = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public items = (state: SmartSearchState) => of([] as SmartSearchFilterValue[]);

  private filterItems = (state: SmartSearchState): Observable<SmartSearchFilterValue[]> => {
    return this.items(state).pipe(
      switchMap((items) =>
        state.leftCaretValue
          ? of(items.filter((item) => item.searchText.toLocaleLowerCase().includes(state.leftCaretValue.toLocaleLowerCase())))
          : of(items)
      )
    );
  };

  @ViewChild(TemplateRef, { static: true }) template: TemplateRef<any>;

  itemFormatter(item: SmartSearchFilterValue): string {
    return item.translation ? this.i18nPipe.transform(item.translation) : item.searchText;
  }

  isSpaceAction(action: ActionType) {
    return action === ActionType.Space;
  }

  actionFormatter(actionType: ActionType) {
    return this.isSpaceAction(actionType) ? 'next filter' : 'another filter value';
  }

  toModelTemplate(): ModelTemplate<SmartSearchFilterValue> {
    return {
      tag: this.tag,
      items: this.filterItems,
      filterByProp: this.filterPropertyName,
      template: this.template,
      itemFormatter: this.itemFormatter.bind(this),
      addGroupBrackets: true,
      isSequenceMultiple: this.isSequenceMultiple,
      enableCacheStorage: this.enableCacheStorage
    };
  }
}
